export const BUILD_SHA = __BUILD_SHA__;
export const BUILD_SHORT_SHA = __BUILD_SHORT_SHA__;
export const VISUAL_QA_ENABLED = __VISUAL_QA__;

export function installBuildProvenance(): void {
  document.documentElement.dataset.build = BUILD_SHORT_SHA;
  document.documentElement.dataset.visualQa = VISUAL_QA_ENABLED ? "true" : "false";
}
